import jQuery from 'jquery';

let $ = jQuery.noConflict();

export default class _f {
    constructor() {
        this.last_scrollTop = 0;
        this.isTouchDevice  = false;

        if ( window.matchMedia("(pointer: coarse)").matches ) {
            this.isTouchDevice = true;
        }
    }

    /**
     * Re-maps a number from one range to another.
     * @param {Int} varA
     * @param {Int} rangeA1
     * @param {Int} rangeA2
     * @param {Int} rangeB1
     * @param {Int} rangeB2
     */
    map_to_range( varA, rangeA1, rangeA2, rangeB1, rangeB2 ) {
        let distA1          = varA - rangeA1;
        let fullRangeA      = rangeA2 - rangeA1;
        let fullRangeB      = rangeB2 - rangeB1;
        let rangeComparison = fullRangeB / fullRangeA;
        let distB1          = distA1 * rangeComparison + rangeB1;
        return distB1;
    }

    /**
     * Splits string at nearest whitespace for a given charcount.
     * @param {String} str
     * @param {Float} max_chars
     */
    split_at_nearest_space( str, max_chars = 30 ) {
        let words        = str.split(' ');
        var split_string = [],
            curr_string  = '';

        words.forEach(( word, index ) => {
            let curr_length = curr_string.length,
                word_length = word.length;
            if ( curr_length + word_length <= max_chars ) {
                curr_string = curr_string + ' ' + word;
            }
            else {
                split_string.push(curr_string.trimLeft());
                curr_string = word;
            }

            if ( index == ( words.length - 1 ) ) {
                split_string.push(curr_string.trimLeft());
            }
        });

        return split_string;
    }

    /**
     * Constrains a given number to min/max values.
     * @param {Float} val
     * @param {Float} min
     * @param {Float} max
     */
    constrain_number_to( val, min, max ) {
        if ( val < min ) {
            return min;
        }
        if ( val > max ) {
            return max;
        }

        return val;
    }

    getScrollDirection( scrollTop ) {
        let SCROLL_THRESHOLD = 2;

        let new_scrollTop = scrollTop,
            direction     = undefined,
            scroll_diff   = Math.abs(this.last_scrollTop - new_scrollTop);

        if ( scroll_diff > SCROLL_THRESHOLD ) {
            if ( new_scrollTop > this.last_scrollTop ) {
                direction = 'DOWN';
            }
            else {
                direction = 'UP';
            }
            this.last_scrollTop = new_scrollTop;
        }
        return direction;
    }

    static formatPrice( price, currency = "EUR" ) {
        return price.toLocaleString(navigator.language, { minimumFractionDigits: 2, style: "currency", currency: currency });
    }

    setCookie( name, value, days ) {
        var expires = "";
        if ( days ) {
            var date = new Date();
            date.setTime(date.getTime() + ( days * 24 * 60 * 60 * 1000 ));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + ( value || "" ) + expires + "; path=/";
    }

}

export const f = new _f();

//
// Array.prototype.forEach2D = (callback) => {
//     this.forEach((column, i) => {
//         column.forEach( (value, j) => {
//             callback(value, i, j);
//         });
//     });
// };
